import axios, { AxiosInstance, AxiosResponse } from "axios";
import { redirect } from "react-router-dom";
import { toast } from "sonner";

const baseURL = import.meta.env.VITE_API_URL;

export type FiltersType = {
  start_date?: string;
  end_date?: string;
  description?: string;
  page?: string | number;
};

export type apiResponseType = Promise<
  AxiosResponse & {
    ok: boolean;
  }
>;

const getMessage = (json: string) => {
  try {
    return JSON.parse(json) || {};
  } catch {
    return {};
  }
};

const logout = () => {
  localStorage.removeItem("auth");
  redirect("/login");
};

export const addInterceptorsResponse = (base: AxiosInstance) => {
  base.interceptors.response.use(
    (response: AxiosResponse) => ({
      ...response,
      ok: response.status === 200,
    }),
    (response) => {

      if (response?.response?.status === 401) {
        toast.error("Sessão expirada, por favor faça login novamente");
        window.location.href = "/login";
        logout();
        return {
          ...response,
          data: {},
          ok: false,
        };
      }

      const messageData = getMessage(response.request?.response);

      let message = messageData?.message || response.code;

      // messageData.response = ['O campo telefone não pode ser superior a 10 caracteres. (e mais 1 erro)', 'teste']

      if (message === "Validation error" && messageData?.response)
        message = messageData.response;

      Array.isArray(message)
        ? message.forEach((msg) => toast.error(`${msg}`))
        : toast.error(`${message}`);

      return {
        ...response,
        data: {},
        ok: false,
      };
    }
  );

  return base;
};

export const api = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
    "ngrok-skip-browser-warning": "true"
  },
});

addInterceptorsResponse(api);

export let apiAuth = api;

export const authorizeRest = ({
  token,
  clientIdUser,
}: {
  token: string;
  clientIdUser?: string;
}) => {
  apiAuth = axios.create({
    baseURL,
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      client_id: clientIdUser,
      "ngrok-skip-browser-warning": "true"
    },
  });

  addInterceptorsResponse(apiAuth);
};
